import React, { Children, useEffect, useMemo, useState } from "react";
import { IoMdClose } from "react-icons/io";
import AppSelectInput from "../../base-components/AppSelectInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Input from "../../Input";
import CustomSelect from "../../CustomSelect";
import { useBankList } from "../../../sevices/hooks/meta-data";
import {
  useCreateLp,
  useLpOtp,
  useResolveBankName,
} from "../../../sevices/hooks/admin";
import { currencyOption } from "../../../pages/dashboard/Settings";
import { IOptionType } from "./stepper/AccessPermission";
import { TransferInfo, useTransferStore } from "../../../store";
import ReactLoading from "react-loading";
interface ModalProps {
  title: string;
  subtitle: string;
  isOpen: boolean;
  onClose: () => void;
  setVerification: (value: boolean) => void;
}

export type IBank = {
  anchorId: string;
  bankName: string;
  cbnCode: string;
  createdAt: string;
  deletedAt: null | string;
  id: string;
  nipCode: string;
  updatedAt: string;
};

const AddLpModal: React.FC<ModalProps> = ({
  title,
  isOpen,
  onClose,
  subtitle,
  setVerification,
}) => {
  const overLayRef = React.useRef(null);
  const handleOverLayClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (e.target === overLayRef.current) {
      onClose();
    }
  };
  const [bank, setBank] = useState<{
    label?: string;
    value?: string;
    bank?: IBank;
  }>({});
  const [WithdrawalBank, setWithdrawalBank] = useState<{
    label?: string;
    value?: string;
    bank?: IBank;
  }>({});
  const [accountNumber, setAccountNumber] = useState("");
  // let bankId = bank?.bank?.id;
  const reqOtp = useLpOtp();
  // const createLpAccount = useCreateLp();
  const [accountName, setAccountName] = useState("");
  const [error, setError] = useState("");
  const getBanks = useBankList();
  const [LP, setLP] = useState("");
  const resolveName = useResolveBankName();
  const [currency, setCurrency] = useState<IOptionType>(null);
  const [loading, setLoading] = useState(false);
  const [withdrawalCurrency, setWithdrawalCurrency] =
    useState<IOptionType>(null);
  const setTransferInfo = useTransferStore((state) => state.setTransferInfo);
  const userDetails = JSON.parse(localStorage.getItem("user") as string);

  // console.log(userDetails);
  useEffect(() => {
    if (accountNumber.length === 10 && bank?.bank) {
      const id = bank.bank?.nipCode || "";
      resolveName
        .mutateAsync({
          bankCode: id,
          accountNumber: accountNumber,
        })
        .then((data: any) => {
          setAccountName(data?.data?.data?.attributes?.accountName);
          setError("");
        })
        .catch((error: any) => {
          setError("Invalid account details");
        });
    }
  }, [accountNumber, bank]);
  const transferData: TransferInfo = {
    name: LP,
    currency: currency ? currency.slug : "",
    bank: bank.value as string,
    AccountNumber: accountNumber,
    AccountName: accountName,
    withdrawalCurrency: withdrawalCurrency ? withdrawalCurrency.slug : "",
    withdrawalBank: WithdrawalBank.value as string,
    otp: "",
  };

  const bankOptions = useMemo(
    () =>
      getBanks?.data?.data?.map((bank: IBank) => ({
        label: bank.bankName,
        value: bank.nipCode,
        bank,
      })),
    [getBanks.data]
  );

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    setTransferInfo(transferData);
    reqOtp
      .mutateAsync({ email: userDetails.email })
      .then((res) => {
        setVerification(true);
        setLoading(false);
        console.log(res);
      })
      .catch((err) => {
        alert("something went wrong");
        setLoading(false);
      });
  };
  return (
    <>
      {isOpen ? (
        <div className="modal  fixed w-full h-full top-0 left-0 justify-center items-center transition-opacity duration-300 z-50">
          <div
            ref={overLayRef}
            className="modal_overlay absolute top-0 right-0 flex justify-end w-full h-full cursor-pointer bg-[#13111173]"
            onClick={handleOverLayClick}
          >
            <div className="modal_box relative bg-[#fff] h-full w-[400px] right-0 rounded-l-lg">
              <div
                onClick={onClose}
                className="close absolute top-1 right-1 flex items-center justify-center rounded-full
                hover:bg-slate-200 p-3 hover:rounded-full hover:text-center "
              >
                <span className="hover:rotate-90 hover:transform  transition duration-150 ease-in-out">
                  <IoMdClose size={29} className="" />
                </span>
              </div>
              <div className="title pt-20 px-5">
                <h1 className="text-2xl  text-[#071827]"> {title}</h1>
                <p className="text-base font-medium text-[#5C6F7F]">
                  {subtitle}
                </p>
              </div>
              <div className="modal_content mx-5 relative h-full">
                <form className="space-y-3" onSubmit={handleSubmit}>
                  <div className="mt-3">
                    <Input
                      label={"Liquidity partner name"}
                      name={"name"}
                      type={"text"}
                      onChange={(e: any) => setLP(e.target.value)}
                    />
                  </div>
                  <div className="mt-3">
                    <AppSelectInput
                      options={currencyOption || []}
                      label=""
                      placeholder="Currency"
                      handleChange={(currency: any) => {
                        setCurrency(currency);
                      }}
                    />
                  </div>
                  <div className="mt-3">
                    <AppSelectInput
                      options={bankOptions || []}
                      label=""
                      placeholder="Bank"
                      handleChange={(bank: any) => {
                        setBank(bank);
                        // setError("");
                      }}
                    />
                  </div>
                  <div className="relative mt-3">
                    <input
                      type="number"
                      name="accNumber"
                      id="accNumber"
                      maxLength={10}
                      placeholder="Account Number"
                      className="p-4 rounded-md bg-[#F2FAF7] border w-full outline-[#0eb683] "
                      required
                      value={accountNumber}
                      onChange={(evt) => {
                        const inputValue = evt.target.value;
                        // setAccNumber(inputValue);
                        // setError("");
                        if (inputValue.length <= 10) {
                          setAccountNumber(inputValue);
                          // setError("");
                        } else {
                          // Trim the input value to 10 characters
                          setAccountNumber(inputValue.slice(0, 10));
                          // setError("");
                        }
                      }}
                    />

                    <div className=" text-xs  ">
                      {
                        resolveName.isLoading && "Validating details.."
                        // : accountName && accountNumber.length === 10
                        // ? accountName
                        // : error
                        // ? ""
                        //     : ""
                      }
                    </div>
                    {/* <div className="text-[#ee0000] font-bold absolute top-3 left-2 ">
                      *
                    </div> */}
                  </div>
                  <div className="mt-3">
                    <Input
                      label={"Account Name"}
                      name={"name"}
                      type={"text"}
                      value={accountName || ""}
                    />
                  </div>
                  <div className="mt-8">
                    <span className="text-base font-medium text-[#5C6F7F]">
                      Select withdrawal bank list
                    </span>
                    <div className="mt-2">
                      <AppSelectInput
                        options={bankOptions || []}
                        label=""
                        placeholder="Currency"
                        handleChange={(cur: any) => {
                          setWithdrawalCurrency(cur);
                          // setError("");
                        }}
                      />
                    </div>
                    <div className="mt-3">
                      <AppSelectInput
                        options={bankOptions || []}
                        label=""
                        placeholder="Bank List"
                        handleChange={(bank: any) => {
                          setWithdrawalBank(bank);
                          // setError("");
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-full  absolute bottom-52">
                    <div className="w-full  ">
                      <button
                        type="submit"
                        className="text-[#fff] bg-[#0eb683]  w-full py-3 rounded-md  active:scale-90 transition-all"
                      >
                        {loading ? (
                          <div className="xxs:ml-14 md:ml-[68px]">
                            <ReactLoading
                              type="spinningBubbles"
                              color="#fff"
                              height="27px"
                              width="27px"
                            />
                          </div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default AddLpModal;
